'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChartOptions = exports.symbolMarkers = exports.FOCUS_COLORS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _getAxisOptions = require('./getAxisOptions');

var _getBaseOptions = require('./getBaseOptions');

var _getGridOptions = require('./getGridOptions');

var _getTooltipOptions = require('./getTooltipOptions');

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOCUS_COLORS = exports.FOCUS_COLORS = {
  highlightColors: ['#E73741', '#0F8FD9', '#993484', '#DF521E', '#719E24', '#E1B400', '#32A674', '#0B68AF'],
  baselineColors: ['#0B1E2D']
};

var symbolMarkers = exports.symbolMarkers = function symbolMarkers() {
  var paths = {
    circle: function circle(size) {
      var r = Math.sqrt(size) / 2;
      return 'M0,' + r + ' A' + r + ',' + r + ' 0 1,1 0,' + -r + ' A' + r + ',' + r + ' 0 1,1 0,' + r + ' Z';
    },
    square: function square(size) {
      var r = Math.sqrt(size) / 2;
      return 'M' + -r + ',' + -r + ' L' + r + ',' + -r + ' ' + r + ',' + r + ' ' + -r + ',' + r + ' Z';
    },
    cross: function cross(size) {
      var r = Math.sqrt(size) / 2;
      return 'M' + -r + ',' + r + ' L' + r + ',' + -r + ' M' + r + ',' + r + ' L' + -r + ',' + -r;
    },
    'triangle': function triangle(size) {
      var rx = Math.sqrt(size) / Math.sqrt(3);
      var ry = Math.sqrt(size) / 2;
      return 'M0,' + -ry + ' L' + rx + ',' + ry + ' ' + -rx + ',' + ry + ' Z';
    }
  };
  return [{ style: { stroke: '#39617D', fill: '#39617D' }, path: paths.circle }, { style: { stroke: '#39617D', fill: '#DBEBF2' }, rotate: 45, path: paths.square }, { style: { stroke: '#39617D', fill: '#39617D', strokeWidth: 2 }, path: paths.cross }, { style: { stroke: '#39617D', fill: '#DBEBF2' }, path: paths.square }, { style: { stroke: '#39617D', fill: '#39617D' }, path: paths.triangle }];
};

var getAnnotationOptions = function getAnnotationOptions(type, options) {
  return R.pipe(R.pathOr({}, ['serie', 'annotation']), R.mergeRight({
    format: {
      datapoint: { proc: function proc(d) {
          return (0, _numeral2.default)(d).format('0,0.[00]');
        } }
    }
  }), R.cond([[R.always(R.equals(_constants.SCATTER, type)), R.mergeRight({ display: 'never' })], [R.always(R.equals(_constants.TIMELINE, type)), R.mergeDeepRight({ format: { datapoint: { pattern: '.2f' } } })], [R.T, R.identity]]))(options);
};

var getChartOptions = exports.getChartOptions = function getChartOptions(data, type, options, tooltipFonts, timeFormats, locale) {
  var defaultSerieColors = R.ifElse(R.anyPass([R.equals(_constants.STACKED_BAR), R.equals(_constants.STACKED_ROW)]), R.always(['#607D8B']), R.always(['#8EA4B1']))(type);

  return {
    axis: (0, _getAxisOptions.getAxisOptions)(data, type, options, timeFormats, locale),
    background: R.pipe(R.propOr({}, 'background'), R.mergeRight({ color: '#DBEBF2' }))(options),
    base: (0, _getBaseOptions.getBaseOptions)(type, options),
    grid: (0, _getGridOptions.getGridOptions)(type, options),
    map: R.pipe(R.propOr({}, 'map'), R.mergeRight({ intBoundariesColor: '#8EA4B1' }))(options),
    serie: (0, _extends3.default)({}, R.propOr({}, 'serie', options), {
      annotation: getAnnotationOptions(type, options),
      choropleth: R.pipe(R.pathOr({}, ['serie', 'choropleth']), R.mergeRight({
        divisions: 4,
        domain: 'YlorRd',
        invert: false,
        labelDisplay: 'none'
      }))(options),
      stacked: R.pipe(R.pathOr({}, ['serie', 'stacked']), R.mergeRight({ strokeThickness: 1, strokeColor: '#F8FAFC' }))(options),
      symbol: R.pipe(R.pathOr({}, ['serie', 'symbol']), R.mergeRight({
        markers: symbolMarkers(),
        markerDefaultSize: 60,
        markerDefaultStrokeWidth: 1,
        gapMinMaxColor: '#607D8B',
        gapMinMaxThickness: 1,
        gapAxisMinColor: 'white',
        gapAxisMinThickness: 1
      }))(options),
      colors: R.pathOr(defaultSerieColors, ['serie', 'colors'], options),
      overColors: R.pathOr(['#39617D'], ['serie', 'overColors'], options),
      highlightColors: R.pathOr(FOCUS_COLORS.highlightColors, ['serie', 'highlightColors'], options),
      baselineColors: R.pathOr(FOCUS_COLORS.baselineColors, ['serie', 'baselineColors'], options),
      tooltip: (0, _getTooltipOptions.getTooltipOptions)(data, type, options, tooltipFonts, timeFormats, locale)
    })
  };
};